export type TSubdomainPolicy = `@${string}`;
export const toSubdomainPolicy = (subdomain: string): TSubdomainPolicy =>
  `@${subdomain}`;
